<div class="ccl-searchbar">
    <!-- Search Icon -->
    @if (showIcon) {
      @if (searchIcon) {
        <ng-container [ngTemplateOutlet]="searchIcon"></ng-container>
      } @else {
        <span class="ccl-searchbar__icon" aria-hidden="true">🔍</span>
      }
    }
  
    <!-- Input -->
    <input
      #inputEl
      type="text"
      class="ccl-searchbar__input"
      role="searchbox"
      [attr.aria-label]="placeholder"
      [placeholder]="placeholder"
      [(ngModel)]="value"
      [disabled]="disabled"
      (input)="handleInput($event)"
      (keyup.enter)="handleEnter()"
      (keyup.escape)="clear()"
    />
  
    <!-- Clear Button -->
    @if (clearable && value) {
      @if (clearIcon) {
        <button
          type="button"
          class="ccl-searchbar__clear"
          aria-label="Clear search"
          (click)="clear()"
        >
          <ng-container [ngTemplateOutlet]="clearIcon"></ng-container>
        </button>
      } @else {
        <button
          type="button"
          class="ccl-searchbar__clear"
          aria-label="Clear search"
          (click)="clear()"
        >
          ✕
        </button>
      }
    }
  </div>
  